<a vbUiBtnPrimary *vbAuthorizationKey="'authenticated'; fallback true" (click)="onClick.emit()">
	<span class="glyphicons user"></span>
	<span>{{ btnLabel || ('SignIn' | translate) }}</span>
</a>